import { EventBus } from '../events/event-bus';
import { EventBusEvent } from '../events/event-bus-events';
import { ServiceLocator } from '../core/service-locator';
export class DemoManager {
    static instance;
    UPDATE_INTERVAL_ = 3000;
    IS_RANDOM_ = true;
    lastTime_ = 0;
    satellite = 0;
    constructor() {
        // Singleton
    }
    static getInstance() {
        if (!DemoManager.instance) {
            DemoManager.instance = new DemoManager();
        }
        return DemoManager.instance;
    }
    init() {
        EventBus.getInstance().on(EventBusEvent.endOfDraw, () => this.update());
    }
    update() {
        if (!settingsManager.isDemoModeOn || !ServiceLocator.getSensorManager()?.isSensorSelected()) {
            return;
        }
        const satData = ServiceLocator.getCatalogManager().objectCache;
        const colorSchemeManagerInstance = ServiceLocator.getColorSchemeManager();
        const realTime = Date.now();
        if (realTime - this.lastTime_ < this.UPDATE_INTERVAL_) {
            return;
        }
        this.lastTime_ = realTime;
        const catalogManagerInstance = ServiceLocator.getCatalogManager();
        const activeSats = catalogManagerInstance.objectCache.filter((sat) => sat.isSatellite() && sat.active);
        const lastSatId = activeSats[activeSats.length - 1].id;
        for (this.satellite; this.satellite < lastSatId;) {
            if (this.IS_RANDOM_) {
                this.satellite = Math.floor(Math.random() * lastSatId);
            }
            const sat = satData[this.satellite];
            if (!sat.isSatellite() ||
                colorSchemeManagerInstance.isPayloadOff(sat) ||
                colorSchemeManagerInstance.isRocketBodyOff(sat) ||
                colorSchemeManagerInstance.isDebrisOff(sat) ||
                colorSchemeManagerInstance.isInViewOff(sat)) {
                continue;
            }
            ServiceLocator.getHoverManager().setHoverId(this.satellite);
            ServiceLocator.getOrbitManager().setSelectOrbit(this.satellite);
            this.satellite++;
            break;
        }
    }
}
